import { ID_TOKEN_KEY } from '@/contexts/workspaceContext';
import { fetchGraphList } from '@/lib/instance_api';
import { useQuery } from 'react-query';

export const useListGraphs = (nginxHost?: string, tgVersion?: string) => {
  return useQuery({
    queryKey: ['graph_list', nginxHost, tgVersion],
    queryFn: async () => {
      if (nginxHost === undefined || tgVersion === undefined) return [];
      return fetchGraphList(nginxHost, tgVersion, sessionStorage.getItem(ID_TOKEN_KEY) as string);
    },
    enabled: Boolean(nginxHost),
  });
};
